import Icon from '../components/Icon.vue'

Icon.register({"file-medical-alt":{"width":448,"height":512,"paths":[{"d":"M288 136V0H88C74.7 0 64 10.7 64 24V256H8C3.6 256 0 259.6 0 264V280C0 284.4 3.6 288 8 288H148.9C151.9 288 154.7 289.7 156.1 292.4L176 332.2 232.8 218.5C235.7 212.6 244.2 212.6 247.1 218.5L281.8 288H352C360.8 288 368 295.2 368 304S360.8 320 352 320H262.1L240 275.8 183.2 389.5C180.3 395.4 171.8 395.4 168.9 389.5L134.1 320H64V488C64 501.3 74.7 512 88 512H424C437.3 512 448 501.3 448 488V160H312C298.8 160 288 149.2 288 136zM441 105L343.1 7C338.6 2.5 332.5 0 326.1 0H320V128H448V121.9C448 115.6 445.5 109.5 441 105z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/file-medical-alt.js